import { lazy } from 'react'

export const AgeV1 = lazy(() => import('./v1/AgeV1'))
export const AgeV2 = lazy(() => import('./v2/AgeV2'))
export const AgeV3 = lazy(() => import('./v3/AgeV3'))
export const AgeV4 = lazy(() => import('./v4/AgeV4'))
